import AssignHomework from './component';

import _routes from './routes';

export const routes = _routes;

export default AssignHomework;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/index.js